module.exports = __webpack_public_path__ + "static/logo-invert-d5d386bab1340555ee74c39aa36d232c.gif";